"use client";

import { useState } from 'react';
import Link from "next/link";
import Slugify from "@/components/Slugify";
import styles from "../page.module.css";

const RelatedThemes = ({ tagThemes, locale }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 3;
    const totalPages = Math.ceil(tagThemes.length / itemsPerPage);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const themesToShow = tagThemes.slice(startIndex, endIndex);

    if (!themesToShow || themesToShow.length === 0) return null;

    return (
        <div className={styles.tagsTemas}>
            <div className="container-l">
                <div className="row d-md-flex g-5">
                    {themesToShow.map((theme, index) => (
                        <div className="col-sm-12 col-md-4" key={`tag-${theme.tagName}-${index}`}>
                            <h3>{theme.tagName}</h3>
                            {theme.posts.length > 0 && (
                                <div key={`post-${theme.tagName}-${index}`} className={styles.postItem}>
                                    {(() => {
                                        // Since we are hydrating, we should use a consistent random or just show the first one
                                        // Using the first one for consistency in SSR/CSR matching, or implementing a stable random if needed.
                                        // For now, let's show the first one to avoid hydration mismatch, or we can use useEffect for random.
                                        // Given the original code used random render, let's stick to simple deterministic for now
                                        // to avoid hydration errors, or use a client-side only random.
                                        // Actually, let's allow it to be random but in a clean way? 
                                        // No, for SSR safety, let's pick the first one or logic that is deterministic.
                                        // The original code re-rendered random on every render? That's chaotic.
                                        // Let's pick the first one for stability.
                                        const randomPost = theme.posts[0];
                                        return (
                                            <p>
                                                <Link href={`/${locale}/${locale === 'es' ? 'noticias' : 'news'}/${Slugify(randomPost.attributes.title)}`}>
                                                    {randomPost.attributes.title}
                                                </Link>
                                            </p>
                                        );
                                    })()}
                                </div>
                            )}
                        </div>
                    ))}

                    <div className={styles.Pagination}>
                        <button
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            className={styles.PageNumber}
                        >
                            <i className="bi bi-chevron-left"></i>
                        </button>
                        <span> <span style={{ fontWeight: 600, color: '#4c6f6a' }}>{currentPage}</span> / {totalPages}</span>

                        <button
                            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                            className={styles.PageNumber}
                        >
                            <i className="bi bi-chevron-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RelatedThemes;
